window.addEventListener('load', function () {
  const orderBy = document.querySelector('.orderby');

  if (orderBy) {
    orderBy.addEventListener('change', function() {
      location.href = location.origin + location.pathname + '?orderby=' + this.value;
    })
  }
})
